var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',{attrs:{"for":""}},[_vm._v(_vm._s(_vm.field.label))]),_c('v-textarea',{attrs:{"outlined":"","color":"primary","rules":_vm.rules,"height":"70"},model:{value:(_vm.formData[_vm.field.key]),callback:function ($$v) {_vm.$set(_vm.formData, _vm.field.key, $$v)},expression:"formData[field.key]"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }